// extracted by mini-css-extract-plugin
export var list = "quotes-module--list--8c67c";
export var listItem = "quotes-module--listItem--a3b55";